export default "__VITE_ASSET__CM$Opsgf__"